"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _1 = require("./../");
const string_1 = require("./utils/string");
exports.DatagridFilters = (props) => {
    const { children, noDefaultFilter, noHeader, properties, sort, onClickClose, onClickResetAll } = props;
    const isDescending = string_1.isSortDescending(sort);
    const sortProperty = string_1.getSortProperty(sort);
    return (React.createElement("div", { className: "bkn-datagrid-filter" },
        !noHeader && (React.createElement("div", { className: "bkn-datagrid-filter-header hidden-xs-down" },
            React.createElement("a", { className: "text-uppercase", href: "#", onClick: onClickResetAll },
                React.createElement("small", null, "Reset All")),
            React.createElement("a", { className: "text-uppercase", href: "#", onClick: onClickClose },
                React.createElement("small", null, "Close")))),
        React.createElement("div", { className: "bkn-datagrid-filter-body" },
            React.createElement("button", { className: "btn btn-sm btn-link text-uppercase btn-close-filters hidden-sm-up", onClick: onClickClose },
                React.createElement(_1.Icon, { name: "close" })),
            !noDefaultFilter && (React.createElement("div", { className: "filter" },
                React.createElement("div", { className: "filter-header" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-8" },
                            React.createElement("h3", { className: "filter-title" }, "Sort by")))),
                React.createElement("div", { className: "filter-body" },
                    React.createElement("div", { className: "filter-input" },
                        React.createElement("select", { className: "form-control custom-select", value: sortProperty, onChange: handleChangeSortProperty(props) }, renderOptionsOfSortByFilter(properties))),
                    React.createElement("div", { className: "filter-input" },
                        React.createElement("div", { className: "form-group" },
                            React.createElement("label", { className: "custom-control custom-radio" },
                                React.createElement("input", { className: "custom-control-input", checked: !isDescending, type: "radio", value: "asc", onChange: handleSortDirection(props) }),
                                React.createElement("span", { className: "custom-control-indicator" }),
                                React.createElement("span", { className: "custom-control-description" }, "Asc")),
                            React.createElement("label", { className: "custom-control custom-radio" },
                                React.createElement("input", { className: "custom-control-input", checked: isDescending, type: "radio", value: "desc", onChange: handleSortDirection(props) }),
                                React.createElement("span", { className: "custom-control-indicator" }),
                                React.createElement("span", { className: "custom-control-description" }, "Desc"))))))),
            children)));
};
exports.DatagridFilters.displayName = 'DatagridFilters';
exports.DatagridFilters.defaultProps = {
    noDefaultFilter: false,
    noHeader: false,
};
const renderOptionsOfSortByFilter = (properties) => properties.map(p => React.createElement("option", { key: p.sortKey, value: p.sortKey }, p.name));
const handleChangeSortProperty = (props) => (e) => {
    const sortProperty = e.target.value;
    const isDescending = string_1.isSortDescending(props.sort);
    const sort = isDescending ? `-${sortProperty}` : sortProperty;
    props.onSort(sort);
};
const handleSortDirection = (props) => (e) => {
    const direction = e.target.value;
    const isDescending = direction === 'desc';
    const sortProperty = string_1.getSortProperty(props.sort);
    const sort = isDescending ? `-${sortProperty}` : sortProperty;
    props.onSort(sort);
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridFilters.tsx
// module id = 245
// module chunks = 0